<template>
  <div id="root">
    <div class="bg-dark app text-white">
      <div class="desktop-layout">
        <!-- Desktop sidebar -->
        <Sidebar v-if="showSidebar" class="desktop-sidebar" />
        <!-- Main content -->
        <div class="main-content" :class="{ 'sidebar-is-open': showSidebar }">
          <div class="container height100">
            <div class="row no-gutter height100">
              <div class="col bg-gradient bg-primary px-0 height100">
                <div class="notification-wrapper" :class="{ 'notification-sidebar-offset': showSidebar }">
                  <div
                    class="notification_box"
                    :style="notificationBoxStyle"
                  >
                    <span :style="{ display: notification != null && notification.type === 'info' ? 'inline-block' : 'none' }" style="flex-basis: 30px; padding: 4px; text-align: center"><FontAwesomeIcon icon="info-circle" class="text-info i"/></span>
                    <span :style="{ display: notification != null && notification.type === 'danger' ? 'inline-block' : 'none' }" style="flex-basis: 30px; padding: 4px; text-align: center"><FontAwesomeIcon icon="exclamation-circle" class="text-danger i"/></span>
                    <span :style="{ display: notification != null && notification.type === 'success' ? 'inline-block' : 'none' }" style="flex-basis: 30px; padding: 4px; text-align: center"><FontAwesomeIcon icon="check-circle" class="text-success i"/></span>
                    <span style="flex: 1; padding: 4px">{{ notification != null ? notification.message : ' ' }}</span>
                  </div>
                </div>
                <router-view/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTE_MENU, ROUTE_BOXES } from '@/const/routeNames'
import Sidebar from '@/components/shared/Sidebar'
import musicboxClient from '@/utils/musicboxClient'
import localStorageUtil from '@/utils/localStorageUtil'

export default {
  name: 'App',

  components: {
    Sidebar
  },
  methods: {
    back (e) {
      e.preventDefault()
      this.$router.back()
    },
    handleResize () {
      const isDesktop = window.innerWidth >= 992
      if (isDesktop && !this.wasDesktop) {
        // Crossed from mobile to desktop: open sidebar
        this.$store.commit('setSidebarOpen', true)
      } else if (!isDesktop && this.wasDesktop) {
        // Crossed from desktop to mobile: close sidebar
        this.$store.commit('setSidebarOpen', false)
      }
      this.wasDesktop = isDesktop
    }
  },
  computed: {
    notification () {
      return this.$store.state.shared.notification
    },
    notificationBoxStyle () {
      if (this.notification != null) { return { opacity: 1, height: 'auto' } }
      return { opacity: 0, height: 0, border: 0 }
    },

    sidebarOpen () {
      return this.$store.state.shared.sidebarOpen
    },
    isAuthorized () {
      return this.$store.state.auth.authorized
    },
    showSidebar () {
      return this.sidebarOpen && this.isAuthorized
    }
  },
  data () {
    return {
      ROUTE_MENU,
      ROUTE_BOXES
    }
  },
  created () {
    // Users who logged in before the app stored the staff flag: fetch it once.
    if (this.isAuthorized && this.$store.state.auth.isStaff === null) {
      musicboxClient.getAccountDetails().then(res => {
        if (typeof res.data.is_staff !== 'boolean') return
        localStorageUtil.setUserIsStaff(res.data.is_staff)
        this.$store.commit('setUserIsStaff', res.data.is_staff)
      }).catch(() => {})
    }
  },
  mounted () {
    this.wasDesktop = window.innerWidth >= 992
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.notification-wrapper {
  z-index: 1100;
  position: fixed;
  top: 48px;
  right: 4px;
  left: 4px;
  transition: left 0.3s ease;
}

.notification_box {
  display: flex;
  background-color: black;
  background-color: #24262B;
  border: solid black 1px;
  transition: opacity 0.4s;
}

/* Mobile: no sidebar layout, everything normal */
.desktop-sidebar {
  display: none;
}

.main-content {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
}

/* Desktop: sidebar layout */
@media (min-width: 992px) {
  .desktop-layout {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
  }

  .desktop-sidebar {
    display: block;
    flex-shrink: 0;
  }

  .main-content {
    flex: 1;
    min-width: 0;
    height: 100vh;
    transition: margin-left 0.3s ease;
  }

  .main-content.sidebar-is-open {
    margin-left: 280px;
  }

  .notification-wrapper.notification-sidebar-offset {
    left: 284px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue